import { sha256 } from '@noble/hashes/sha2';
import { bytesToHex } from '@noble/hashes/utils';

import { CurrencyWarning } from '@flipster/apis/v1/currency/types';

interface GetCurrencyWarningStorageKeyParams {
  userId: string;
  warningData: Omit<CurrencyWarning, 'type'>;
}

export const getCurrencyWarningStorageKey = ({
  userId,
  warningData: { currency, blockchainName = 'INTERNAL', title, body },
}: GetCurrencyWarningStorageKeyParams) => {
  const hashString = bytesToHex(sha256(`${currency}-${blockchainName}-${title}-${body}`));
  const storageKey = `flipster.configs.v1.${String(userId)}.${hashString}.skipCurrencyWarningConfirm` as const;
  return storageKey;
};
